import { ClinicsPage } from "./ClinicsPage";
export default ClinicsPage;
